import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordForm"] */ "/builds/vivaldis/vivaldis_interim/frontend/src/app/[locale]/myvivaldis/(auth)/forgot-password/components/forms/ForgotPasswordForm.tsx");
;
import(/* webpackMode: "eager" */ "/builds/vivaldis/vivaldis_interim/frontend/src/assets/images/social_share.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/vivaldis/vivaldis_interim/frontend/src/components/blocks/TranslatedPaths.tsx");
